import { PubMainTypeEnum } from '../../../types';
export var showSources = function showSources(source) {
  switch (source) {
    case PubMainTypeEnum.PUB_NEWSPAPER:
      return 'Newspaper';
    case PubMainTypeEnum.PUB_JOURNAL:
      return 'Journal';
    default:
      return 'Magazine';
  }
};